module.exports = __webpack_public_path__ + "img/wjsc.04070d99.png";